import * as Clipboard from 'expo-clipboard'
import { useState, type MouseEvent as ReactMouseEvent, type ReactNode } from 'react'
import type { GestureResponderEvent } from 'react-native'

import { Button, type TDefaultButtonProps } from '@/src/elements/button/default'
import { ICON } from '@/src/general/enums/icons'
import { useTranslate } from '@/src/lang/useTranslate'

export type TCopyButtonProps = {
  link: string
} & TDefaultButtonProps

export const CopyButton = ({ children, link, onPress: onHandlePress, ...otherProps }: TCopyButtonProps): ReactNode => {
  const [hasCopied, setHasCopied] = useState(false)
  const { t } = useTranslate()

  const copyToClipboard = async () => {
    await Clipboard.setStringAsync(link)
  }

  const handlePress = async (e: GestureResponderEvent | ReactMouseEvent) => {
    setHasCopied(true)
    await copyToClipboard()
    if (onHandlePress) {
      onHandlePress(e)
    }
    setTimeout(() => {
      setHasCopied(false)
    }, 3000)
  }

  if (hasCopied) {
    return (
      <Button colors="success" variant="faded" startIcon={ICON.CHECK_CIRCLE_BROKEN} {...otherProps}>
        {children || t('share.copied-link')}
      </Button>
    )
  }

  return (
    <Button colors="primary" variant="solid" startIcon={ICON.LINK} onPress={handlePress} {...otherProps}>
      {children || t('share.copy-link')}
    </Button>
  )
}
